export default __webpack_public_path__ + "static/media/Icon menu Campaign _ Active.373e65a5.svg";